const topbar = {
    docs: 'Documentos',
    help: 'Ayuda',
    subscription: 'Suscripción',
};
export default Object.freeze(topbar);
